"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;

/**
 * Master list of valid schemas for analytics actions
 *
 * Each event describes one ActionType
 */

/**
 * The top-level actions an Event describes.
 *
 * Each ActionType corresponds with a table in Redshift.
 */
var ActionType;
exports.ActionType = ActionType;

(function (ActionType) {
  ActionType["authImpression"] = "authImpression";
  ActionType["addToCalendar"] = "addToCalendar";
  ActionType["addCollectedArtwork"] = "addCollectedArtwork";
  ActionType["artworkDetailsCompleted"] = "artworkDetailsCompleted";
  ActionType["auctionPageView"] = "auctionPageView";
  ActionType["auctionResultsFilterParamsChanged"] = "auctionResultsFilterParamsChanged";
  ActionType["bidPageView"] = "bidPageView";
  ActionType["clickedActiveBid"] = "clickedActiveBid";
  ActionType["clickedAddNewShippingAddress"] = "clickedAddNewShippingAddress";
  ActionType["clickedAddWorksToFair"] = "clickedAddWorksToFair";
  ActionType["clickedAppDownload"] = "clickedAppDownload";
  ActionType["clickedArticleGroup"] = "clickedArticleGroup";
  ActionType["clickedArticleShare"] = "clickedArticleShare";
  ActionType["clickedArtistGroup"] = "clickedArtistGroup";
  ActionType["clickedArtistSeriesGroup"] = "clickedArtistSeriesGroup";
  ActionType["clickedArtworkGroup"] = "clickedArtworkGroup";
  ActionType["clickedAuctionGroup"] = "clickedAuctionGroup";
  ActionType["clickedBuyerProtection"] = "clickedBuyerProtection";
  ActionType["clickedChangePage"] = "clickedChangePage";
  ActionType["clickedChangeShippingAddress"] = "clickedChangeShippingAddress";
  ActionType["clickedChangeShippingMethod"] = "clickedChangeShippingMethod";
  ActionType["clickedChangePaymentMethod"] = "clickedChangePaymentMethod";
  ActionType["clickedCollectionGroup"] = "clickedCollectionGroup";
  ActionType["clickedCreateAlert"] = "clickedCreateAlert";
  ActionType["clickedDeliveryMethod"] = "clickedDeliveryMethod";
  ActionType["clickedEditArtwork"] = "clickedEditArtwork";
  ActionType["clickedExpansionToggle"] = "clickedExpansionToggle";
  ActionType["clickedExternalNewsSource"] = "clickedExternalNewsSource";
  ActionType["clickedFairCard"] = "clickedFairCard";
  ActionType["clickedFairGroup"] = "clickedFairGroup";
  ActionType["clickedGalleryGroup"] = "clickedGalleryGroup";
  ActionType["clickedLoadMore"] = "clickedLoadMore";
  ActionType["clickedMainArtworkGrid"] = "clickedMainArtworkGrid";
  ActionType["clickedNavigationTab"] = "clickedNavigationTab";
  ActionType["clickedOfferOption"] = "clickedOfferOption";
  ActionType["clickedOnArtworkShippingUnitsDropdown"] = "clickedOnArtworkShippingUnitsDropdown";
  ActionType["clickedOnArtworkShippingWeight"] = "clickedOnArtworkShippingWeight";
  ActionType["clickedOnFramedMeasurements"] = "clickedOnFramedMeasurements";
  ActionType["clickedOnFramedMeasurementsDropdown"] = "clickedOnFramedMeasurementsDropdown";
  ActionType["clickedOnSubmitOrder"] = "clickedOnSubmitOrder";
  ActionType["clickedSnooze"] = "clickedSnooze";
  ActionType["clickedPartnerCard"] = "clickedPartnerCard";
  ActionType["clickedPartnerLink"] = "clickedPartnerLink";
  ActionType["clickedPlayVideo"] = "clickedPlayVideo";
  ActionType["clickedPaymentMethod"] = "clickedPaymentMethod";
  ActionType["clickedPaymentDetails"] = "clickedPaymentDetails";
  ActionType["checkedAccountBalance"] = "checkedAccountBalance";
  ActionType["clickedPromoSpace"] = "clickedPromoSpace";
  ActionType["clickedRegisterToBid"] = "clickedRegisterToBid";
  ActionType["clickedSelectShippingOption"] = "clickedSelectShippingOption";
  ActionType["clickedShippingAddress"] = "clickedShippingAddress";
  ActionType["clickedShowGroup"] = "clickedShowGroup";
  ActionType["clickedShowMore"] = "clickedShowMore";
  ActionType["clickedSponsorLink"] = "clickedSponsorLink";
  ActionType["clickedTooltip"] = "clickedTooltip";
  ActionType["clickedVerifyIdentity"] = "clickedVerifyIdentity";
  ActionType["clickedViewingRoomCard"] = "clickedViewingRoomCard";
  ActionType["clickedOfferActions"] = "clickedOfferActions";
  ActionType["clickedOrderPage"] = "clickedOrderPage";
  ActionType["commercialFilterParamsChanged"] = "commercialFilterParamsChanged";
  ActionType["completedOnboarding"] = "completedOnboarding";
  ActionType["confirmBid"] = "confirmBid";
  ActionType["confirmRegistrationPageview"] = "confirmRegistrationPageview";
  ActionType["consignmentArtistFailed"] = "consignmentArtistFailed";
  ActionType["consignmentSubmitted"] = "consignmentSubmitted";
  ActionType["contactInformationCompleted"] = "contactInformationCompleted";
  ActionType["contactGallery"] = "contactGallery";
  ActionType["createdAccount"] = "createdAccount";
  ActionType["deleteCollectedArtwork"] = "deleteCollectedArtwork";
  ActionType["deletedSavedSearch"] = "deletedSavedSearch";
  ActionType["editCollectedArtwork"] = "editCollectedArtwork";
  ActionType["editedSavedSearch"] = "editedSavedSearch";
  ActionType["enterLiveAuction"] = "enterLiveAuction";
  ActionType["focusedOnConversationMessageInput"] = "focusedOnConversationMessageInput";
  ActionType["focusedOnSearchInput"] = "focusedOnSearchInput";
  ActionType["focusedOnPriceDatabaseSearchInput"] = "focusedOnPriceDatabaseSearchInput";
  ActionType["followedArtist"] = "followedArtist";
  ActionType["followedFair"] = "followedFair";
  ActionType["followedGene"] = "followedGene";
  ActionType["followedPartner"] = "followedPartner";
  ActionType["impression"] = "impression";
  ActionType["maxBidSelected"] = "maxBidSelected";
  ActionType["onboardingUserInputData"] = "onboardingUserInputData";
  ActionType["priceDatabaseFilterParamsChanged"] = "priceDatabaseFilterParamsChanged";
  ActionType["promptForReview"] = "promptForReview";
  ActionType["registrationPageView"] = "registrationPageView";
  ActionType["registrationSubmitted"] = "registrationSubmitted";
  ActionType["resetYourPassword"] = "resetYourPassword";
  ActionType["saleScreenLoadComplete"] = "saleScreenLoadComplete";
  ActionType["screen"] = "screen";
  ActionType["searchedPriceDatabase"] = "searchedPriceDatabase";
  ActionType["searchedWithNoResults"] = "searchedWithNoResults";
  ActionType["selectedItemFromSearch"] = "selectedItemFromSearch";
  ActionType["selectedItemFromPriceDatabaseSearch"] = "selectedItemFromPriceDatabaseSearch";
  ActionType["sentArtworkInquiry"] = "sentArtworkInquiry";
  ActionType["sentConversationMessage"] = "sentConversationMessage";
  ActionType["sentRequestPriceEstimate"] = "sentRequestPriceEstimate";
  ActionType["share"] = "share";
  ActionType["experimentViewed"] = "experimentViewed";
  ActionType["startedOnboarding"] = "startedOnboarding";
  ActionType["submitAnotherArtwork"] = "submitAnotherArtwork";
  ActionType["successfullyLoggedIn"] = "successfullyLoggedIn";
  ActionType["tappedArticleGroup"] = "tappedArticleGroup";
  ActionType["tappedShowGroup"] = "tappedShowGroup";
  ActionType["tappedArtistGroup"] = "tappedArtistGroup";
  ActionType["tappedArtistSeriesGroup"] = "tappedArtistSeriesGroup";
  ActionType["tappedArtworkGroup"] = "tappedArtworkGroup";
  ActionType["tappedAuctionGroup"] = "tappedAuctionGroup";
  ActionType["tappedAuctionResultGroup"] = "tappedAuctionResultGroup";
  ActionType["tappedBid"] = "tappedBid";
  ActionType["tappedBuyNow"] = "tappedBuyNow";
  ActionType["tappedCollectedArtwork"] = "tappedCollectedArtwork";
  ActionType["tappedMyCollectionAddArtworkArtist"] = "tappedMyCollectionAddArtworkArtist";
  ActionType["tappedCollectedArtworkImages"] = "tappedCollectedArtworkImages";
  ActionType["tappedCollectionGroup"] = "tappedCollectionGroup";
  ActionType["tappedConsign"] = "tappedConsign";
  ActionType["tappedContactGallery"] = "tappedContactGallery";
  ActionType["tappedCreateAlert"] = "tappedCreateAlert";
  ActionType["tappedExploreGroup"] = "tappedExploreGroup";
  ActionType["tappedFairGroup"] = "tappedFairGroup";
  ActionType["tappedFairCard"] = "tappedFairCard";
  ActionType["tappedInboxConversation"] = "tappedInboxConversation";
  ActionType["tappedInfoBubble"] = "tappedInfoBubble";
  ActionType["tappedLink"] = "tappedLink";
  ActionType["tappedMainArtworkGrid"] = "tappedMainArtworkGrid";
  ActionType["tappedMakeOffer"] = "tappedMakeOffer";
  ActionType["tappedNavigationTab"] = "tappedNavigationTab";
  ActionType["tappedPartnerCard"] = "tappedPartnerCard";
  ActionType["tappedPromoSpace"] = "tappedPromoSpace";
  ActionType["tappedRegisterToBid"] = "tappedRegisterToBid";
  ActionType["tappedRequestPriceEstimate"] = "tappedRequestPriceEstimate";
  ActionType["tappedSell"] = "tappedSell";
  ActionType["tappedSellArtwork"] = "tappedSellArtwork";
  ActionType["tappedShowMore"] = "tappedShowMore";
  ActionType["tappedLearnMore"] = "tappedLearnMore";
  ActionType["tappedSkip"] = "tappedSkip";
  ActionType["tappedTabBar"] = "tappedTabBar";
  ActionType["tappedVerifyIdentity"] = "tappedVerifyIdentity";
  ActionType["tappedViewingRoomCard"] = "tappedViewingRoomCard";
  ActionType["tappedViewingRoomGroup"] = "tappedViewingRoomGroup";
  ActionType["tappedViewOffer"] = "tappedViewOffer";
  ActionType["tappedUploadAnotherArtwork"] = "tappedUploadAnotherArtwork";
  ActionType["timeOnPage"] = "timeOnPage";
  ActionType["toggledAccordion"] = "toggledAccordion";
  ActionType["toggledNotification"] = "toggledNotification";
  ActionType["toggledSavedSearch"] = "toggledSavedSearch";
  ActionType["unfollowedArtist"] = "unfollowedArtist";
  ActionType["unfollowedFair"] = "unfollowedFair";
  ActionType["unfollowedGene"] = "unfollowedGene";
  ActionType["unfollowedPartner"] = "unfollowedPartner";
  ActionType["uploadPhotosCompleted"] = "uploadPhotosCompleted";
  ActionType["viewArtworkMyCollection"] = "viewArtworkMyCollection";
})(ActionType || (exports.ActionType = ActionType = {}));